import {
    Avatar,
    Button,
    Container,
    Grid,
    Hidden,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
} from "@material-ui/core";
import { KeyboardBackspace } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import hallImg from "../../../assets/images/processing.png";
import SharePop from "../../../components/common/shareLivestream";
import Modal from "../../../components/Modal/Modal";
import { IsNullOrEmpty } from "../../../helpers/utility";
import {
    createBookMarkRequest,
    deleteLiveStreamRequest,
    fetchEventRequest,
} from "../../../store/social/social.actions";
import {
    getEvents,
    getLiveStream,
} from "../../../store/social/social.selector";
import { getImage, getUserProfile } from "../../../store/user/user.selector";
import Info from "./Info";
import Product from "./Product";

const Replay = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [playList, setPlayList] = useState([]);
    const [currentVideo, setCurrentVideo] = useState(0);
    const [shareModal, setShareModal] = useState(false);
    const { livestream, userProfile, comments } = useSelector((state) => {
        return {
            livestream: getLiveStream(state),
            userProfile: getUserProfile(state),
            comments: getEvents(state),
        };
    });

    useEffect(() => {
        if (livestream._id) {
            dispatch(fetchEventRequest("?where=livestream:" + livestream._id));
            let playlists = [];
            
            if (
                !IsNullOrEmpty(livestream.streamUrl) &&
                livestream.streamUrl.indexOf("png") === -1
            ) {
                playlists = livestream.streamUrl.split(",").map((s) => s.split("?")[0]);
                if (playlists.length > 0) {
                    setPlayList(playlists);
                }
            }
            else if (!IsNullOrEmpty(livestream.s3Url)) {
                playlists = livestream.s3Url.split(",").map((s) => s.split("?")[0]);
                if (playlists.length > 0) {
                    setPlayList(playlists);
                    setCurrentVideo(0);
                }
            }
        }
    }, [livestream]);

    const shareUrl =
        process.env.REACT_APP_URL + "/video/" + livestream._id;

    let Routes = [
        { id: 0, route: "chat", path: "/page/replay/replayChat" },
        { id: 1, route: "info", path: "/page/replay/info" },
        { id: 2, route: "product", path: "/page/replay/product" },
        { id: 3, route: "Audience", path: "/page/replay/audience" },
    ];

    if (comments.length === 0) {
        Routes = Routes.filter((x) => x.id !== 0);
    }

    if (livestream.products.length === 0) {
        Routes = Routes.filter((x) => x.id !== 2);
    }

    if (livestream.guestInfo.length === 0) {
        Routes = Routes.filter((x) => x.id !== 3);
    }

    if (livestream.parent === "638647e2afec127d1e023777") {
        Routes = Routes.filter((x) => x.id !== 1);
    }
    if (
        comments.length === 0 &&
        livestream.products.length === 0 &&
        livestream.guestInfo.length === 0
    ) {
        Routes = [];
    }

    return (
        <div className="px-2 sm:px-4 py-7 lg:p-0 lg:h-full lg:overflow-hidden">
            <div className="flex flex-col lg:flex-row ">
                <div className="flex-1 h-full lg:m-3 mb-4">
                    <div className="w-full ">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12}>
                                <List disablePadding>
                                    <ListItem disableGutters>
                                        <a
                                            onClick={() => navigate(-1)}
                                            className="text-md font-medium text-black-90"
                                        >
                                            <KeyboardBackspace />
                                        </a>
                                        <ListItemAvatar>
                                            <Avatar
                                                src={getImage(
                                                    livestream.owner.attachments
                                                )}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={
                                                <h3 className="text-black-100 px-2 overflow-text">
                                                    {livestream.title}
                                                </h3>
                                            }

                                        />
                                        <ListItemSecondaryAction>
                                            <>
                                                <Hidden implementation="js" only={["xs", "sm"]}>
                                                    <div
                                                        className={`flex flex-wrap lg:flex-nowrap items-center gap-x-4 md:gap-x-9 gap-y-3 pt-[11px] px-4 ${Routes.length === 0 ? "my-5" : ""
                                                            }`}
                                                    >
                                                        <div className="flex items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                            <span>
                                                                <svg
                                                                    width="20"
                                                                    height="20"
                                                                    viewBox="0 0 20 20"
                                                                    className="stroke-current  mr-1.5 md:mr-2.5"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M6.68387 11.3419C6.88616 10.9381 7 10.4824 7 10C7 9.51763 6.88616 9.06185 6.68387 8.65807M6.68387 11.3419C6.19134 12.3251 5.17449 13 4 13C2.34315 13 1 11.6569 1 10C1 8.34315 2.34315 7 4 7C5.17449 7 6.19134 7.67492 6.68387 8.65807M6.68387 11.3419L13.3161 14.6581M6.68387 8.65807L13.3161 5.34193M13.3161 5.34193C13.8087 6.32508 14.8255 7 16 7C17.6569 7 19 5.65685 19 4C19 2.34315 17.6569 1 16 1C14.3431 1 13 2.34315 13 4C13 4.48237 13.1138 4.93815 13.3161 5.34193ZM13.3161 14.6581C13.1138 15.0619 13 15.5176 13 16C13 17.6569 14.3431 19 16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.8255 13 13.8087 13.6749 13.3161 14.6581Z"
                                                                        strokeWidth="1.5"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                </svg>
                                                            </span>
                                                            <button
                                                                onClick={() => setShareModal(true)}
                                                                className="text-sm font-medium capitalize"
                                                            >
                                                                Share
                                                            </button>
                                                        </div>

                                                        <div className="flex items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                            <span>
                                                                <svg
                                                                    width="22"
                                                                    height="20"
                                                                    viewBox="0 0 22 20"
                                                                    className="stroke-current  mr-1.5 md:mr-2.5"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M10.049 1.92664C10.3483 1.00537 11.6517 1.00538 11.951 1.92664L13.4699 6.60055C13.6038 7.01254 13.9877 7.29148 14.4209 7.29149L19.3354 7.29168C20.3041 7.29172 20.7068 8.53127 19.9232 9.10067L15.9474 11.9895C15.5969 12.2441 15.4503 12.6955 15.5841 13.1075L17.1026 17.7815C17.4019 18.7028 16.3475 19.4689 15.5638 18.8995L11.5878 16.011C11.2373 15.7564 10.7627 15.7564 10.4122 16.011L6.43622 18.8995C5.65252 19.4689 4.5981 18.7028 4.8974 17.7815L6.41589 13.1075C6.54974 12.6955 6.40309 12.2441 6.05263 11.9895L2.07683 9.10067C1.29317 8.53127 1.69592 7.29172 2.66461 7.29168L7.57911 7.29149C8.01231 7.29148 8.39623 7.01254 8.53011 6.60055L10.049 1.92664Z"
                                                                        strokeWidth="1.5"
                                                                        stroke={
                                                                            livestream.isBookmark
                                                                                ? "purple"
                                                                                : "black"
                                                                        }
                                                                    />
                                                                </svg>
                                                            </span>
                                                            <button
                                                                disabled={livestream.isBookmark}
                                                                onClick={() => {
                                                                    dispatch(
                                                                        createBookMarkRequest({
                                                                            livestream: livestream._id,
                                                                        })
                                                                    );
                                                                }}
                                                                style={{
                                                                    color: livestream.isBookmark
                                                                        ? "purple"
                                                                        : "black",
                                                                }}
                                                                className="text-sm font-medium capitalize"
                                                            >
                                                                {livestream.isBookmark ? "Starred" : "Star"}
                                                            </button>
                                                        </div>

                                                        <div className="flex items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                            <span>
                                                                <svg
                                                                    width="20"
                                                                    height="18"
                                                                    viewBox="0 0 20 18"
                                                                    className=" mr-1.5 md:mr-2.5 stroke-current"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M1 7H11C15.4183 7 19 10.5817 19 15V17M1 7L7 13M1 7L7 1"
                                                                        strokeWidth="1.5"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                </svg>
                                                            </span>
                                                            <button className="text-sm font-medium capitalize">
                                                                replay
                                                            </button>
                                                        </div>

                                                        <div className="flex items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                            <span>
                                                                <svg
                                                                    width="22"
                                                                    height="20"
                                                                    viewBox="0 0 22 20"
                                                                    className=" mr-1.5 md:mr-2.5 stroke-current"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M6.5 6.25H15.5M6.5 9.25H11M1.25 10.76C1.25 12.36 2.373 13.754 3.957 13.987C5.086 14.153 6.227 14.28 7.38 14.366C7.73 14.392 8.05 14.576 8.245 14.867L11 19L13.755 14.867C13.8516 14.7233 13.9798 14.6034 14.1297 14.5166C14.2795 14.4298 14.4472 14.3783 14.62 14.366C15.7652 14.2805 16.9069 14.1541 18.043 13.987C19.627 13.754 20.75 12.361 20.75 10.759V4.741C20.75 3.139 19.627 1.746 18.043 1.513C15.711 1.17072 13.357 0.99926 11 1C8.608 1 6.256 1.175 3.957 1.513C2.373 1.746 1.25 3.14 1.25 4.741V10.759V10.76Z"
                                                                        strokeWidth="1.5"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                </svg>
                                                            </span>
                                                            <button
                                                                onClick={() =>
                                                                    navigate("/page/chat", {
                                                                        state: {
                                                                            userId: livestream.owner._id,
                                                                        },
                                                                    })
                                                                }
                                                                className="text-sm font-medium capitalize"
                                                            >
                                                                Go to chatroom
                                                            </button>
                                                        </div>
                                                        {userProfile._id === livestream.owner._id && (
                                                            <div
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    Swal.fire({
                                                                        title: "Confirm delete?",
                                                                        text: "A deleted livestream cannot be restored later.",
                                                                        icon: "warning",
                                                                        showCancelButton: true,
                                                                        confirmButtonColor: "red",
                                                                        cancelButtonText: "Cancel",
                                                                        confirmButtonText: "Delete",
                                                                        customClass: {
                                                                            cancelButton:
                                                                                "order-1 right-gap",
                                                                            confirmButton: "order-2",
                                                                            denyButton: "order-3",
                                                                        },
                                                                    }).then((result) => {
                                                                        if (result.isConfirmed) {
                                                                            setTimeout(() => {
                                                                                navigate("/");
                                                                            }, 1000);
                                                                            dispatch(
                                                                                deleteLiveStreamRequest(
                                                                                    livestream._id
                                                                                )
                                                                            );
                                                                        }
                                                                    });
                                                                }}
                                                                className="flex items-center text-black-60 hover:text-orange-color cursor-pointer"
                                                            >
                                                                <span>
                                                                    <svg
                                                                        width="18"
                                                                        height="20"
                                                                        viewBox="0 0 18 20"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M16 5L15.1327 17.1425C15.0579 18.1891 14.187 19 13.1378 19H4.86224C3.81296 19 2.94208 18.1891 2.86732 17.1425L2 5M7 9V15M11 9V15M12 5V2C12 1.44772 11.5523 1 11 1H7C6.44772 1 6 1.44772 6 2V5M1 5H17"
                                                                            stroke="black"
                                                                            stroke-opacity="0.5"
                                                                            stroke-width="1.5"
                                                                            stroke-linecap="round"
                                                                            stroke-linejoin="round"
                                                                        />
                                                                    </svg>
                                                                </span>
                                                                <button className="ml-2 text-sm font-medium capitalize">
                                                                    Delete
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </Hidden>
                                                <Hidden implementation="js" only={["md", "lg", "xl"]}>
                                                    {livestream.parent !== "638647e2afec127d1e023777" && (
                                                        <div
                                                            className={`flex flex-wrap lg:flex-nowrap items-center gap-x-4 md:gap-x-9 gap-y-3 pt-[11px] px-4 ${Routes.length === 0 ? "my-5" : ""
                                                                }`}
                                                        >
                                                            <div className="flex items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                                <span>
                                                                    <svg
                                                                        onClick={() => setShareModal(true)}
                                                                        width="20"
                                                                        height="20"
                                                                        viewBox="0 0 20 20"
                                                                        className="stroke-current  mr-1.5 md:mr-2.5"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M6.68387 11.3419C6.88616 10.9381 7 10.4824 7 10C7 9.51763 6.88616 9.06185 6.68387 8.65807M6.68387 11.3419C6.19134 12.3251 5.17449 13 4 13C2.34315 13 1 11.6569 1 10C1 8.34315 2.34315 7 4 7C5.17449 7 6.19134 7.67492 6.68387 8.65807M6.68387 11.3419L13.3161 14.6581M6.68387 8.65807L13.3161 5.34193M13.3161 5.34193C13.8087 6.32508 14.8255 7 16 7C17.6569 7 19 5.65685 19 4C19 2.34315 17.6569 1 16 1C14.3431 1 13 2.34315 13 4C13 4.48237 13.1138 4.93815 13.3161 5.34193ZM13.3161 14.6581C13.1138 15.0619 13 15.5176 13 16C13 17.6569 14.3431 19 16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.8255 13 13.8087 13.6749 13.3161 14.6581Z"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                </span>
                                                            </div>

                                                            <div className="flex items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                                <span>
                                                                    <svg
                                                                        onClick={() => {
                                                                            dispatch(
                                                                                createBookMarkRequest({
                                                                                    livestream: livestream._id,
                                                                                })
                                                                            );
                                                                        }}
                                                                        width="22"
                                                                        height="20"
                                                                        viewBox="0 0 22 20"
                                                                        className="stroke-current  mr-1.5 md:mr-2.5"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M10.049 1.92664C10.3483 1.00537 11.6517 1.00538 11.951 1.92664L13.4699 6.60055C13.6038 7.01254 13.9877 7.29148 14.4209 7.29149L19.3354 7.29168C20.3041 7.29172 20.7068 8.53127 19.9232 9.10067L15.9474 11.9895C15.5969 12.2441 15.4503 12.6955 15.5841 13.1075L17.1026 17.7815C17.4019 18.7028 16.3475 19.4689 15.5638 18.8995L11.5878 16.011C11.2373 15.7564 10.7627 15.7564 10.4122 16.011L6.43622 18.8995C5.65252 19.4689 4.5981 18.7028 4.8974 17.7815L6.41589 13.1075C6.54974 12.6955 6.40309 12.2441 6.05263 11.9895L2.07683 9.10067C1.29317 8.53127 1.69592 7.29172 2.66461 7.29168L7.57911 7.29149C8.01231 7.29148 8.39623 7.01254 8.53011 6.60055L10.049 1.92664Z"
                                                                            strokeWidth="1.5"
                                                                            stroke={
                                                                                livestream.isBookmark
                                                                                    ? "purple"
                                                                                    : "black"
                                                                            }
                                                                        />
                                                                    </svg>
                                                                </span>
                                                            </div>

                                                            <div className="flex items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                                <span>
                                                                    <svg
                                                                        width="20"
                                                                        height="18"
                                                                        viewBox="0 0 20 18"
                                                                        className=" mr-1.5 md:mr-2.5 stroke-current"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M1 7H11C15.4183 7 19 10.5817 19 15V17M1 7L7 13M1 7L7 1"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                </span>
                                                            </div>

                                                            <div className="flex items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                                <span>
                                                                    <svg
                                                                        onClick={() =>
                                                                            navigate("/page/chat", {
                                                                                state: {
                                                                                    userId: livestream.owner._id,
                                                                                },
                                                                            })
                                                                        }
                                                                        width="22"
                                                                        height="20"
                                                                        viewBox="0 0 22 20"
                                                                        className=" mr-1.5 md:mr-2.5 stroke-current"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M6.5 6.25H15.5M6.5 9.25H11M1.25 10.76C1.25 12.36 2.373 13.754 3.957 13.987C5.086 14.153 6.227 14.28 7.38 14.366C7.73 14.392 8.05 14.576 8.245 14.867L11 19L13.755 14.867C13.8516 14.7233 13.9798 14.6034 14.1297 14.5166C14.2795 14.4298 14.4472 14.3783 14.62 14.366C15.7652 14.2805 16.9069 14.1541 18.043 13.987C19.627 13.754 20.75 12.361 20.75 10.759V4.741C20.75 3.139 19.627 1.746 18.043 1.513C15.711 1.17072 13.357 0.99926 11 1C8.608 1 6.256 1.175 3.957 1.513C2.373 1.746 1.25 3.14 1.25 4.741V10.759V10.76Z"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                </span>
                                                            </div>
                                                            {userProfile._id === livestream.owner._id && (
                                                                <div
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        Swal.fire({
                                                                            title: "Confirm delete?",
                                                                            text: "A deleted livestream cannot be restored later.",
                                                                            icon: "warning",
                                                                            showCancelButton: true,
                                                                            confirmButtonColor: "red",
                                                                            cancelButtonText: "Cancel",
                                                                            confirmButtonText: "Delete",
                                                                            customClass: {
                                                                                cancelButton:
                                                                                    "order-1 right-gap",
                                                                                confirmButton: "order-2",
                                                                                denyButton: "order-3",
                                                                            },
                                                                        }).then((result) => {
                                                                            if (result.isConfirmed) {
                                                                                setTimeout(() => {
                                                                                    navigate("/");
                                                                                }, 1000);
                                                                                dispatch(
                                                                                    deleteLiveStreamRequest(
                                                                                        livestream._id
                                                                                    )
                                                                                );
                                                                            }
                                                                        });
                                                                    }}
                                                                    className="flex items-center text-black-60 hover:text-orange-color cursor-pointer"
                                                                >
                                                                    <span>
                                                                        <svg
                                                                            width="18"
                                                                            height="20"
                                                                            viewBox="0 0 18 20"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path
                                                                                d="M16 5L15.1327 17.1425C15.0579 18.1891 14.187 19 13.1378 19H4.86224C3.81296 19 2.94208 18.1891 2.86732 17.1425L2 5M7 9V15M11 9V15M12 5V2C12 1.44772 11.5523 1 11 1H7C6.44772 1 6 1.44772 6 2V5M1 5H17"
                                                                                stroke="black"
                                                                                stroke-opacity="0.5"
                                                                                stroke-width="1.5"
                                                                                stroke-linecap="round"
                                                                                stroke-linejoin="round"
                                                                            />
                                                                        </svg>
                                                                    </span>

                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </Hidden>
                                            </>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                </List>
                            </Grid>
                        </Grid>

                        {playList.length === 0 ? (
                            <div className="flex items-center justify-center bg-white w-full h-[70vh]">
                                <img
                                    src={hallImg}
                                    className="w-[250px] h-[250px]"
                                />
                            </div>
                        ) : (
                            <Container maxWidth="md" >
                                <div className="player-wrapper">
                                    <ReactPlayer
                                        playing
                                        url={playList[currentVideo]}
                                        config={{
                                            file: {
                                                attributes:
                                                    livestream.owner._id !==
                                                        userProfile._id
                                                        ? { controlsList: "nodownload" }
                                                        : {},
                                            },
                                        }}
                                        width="100%"
                                        height="100%"
                                        className="react-player"
                                        controls
                                        onError={() => {
                                            if (currentVideo + 1 < playList.length) {
                                                setCurrentVideo(currentVideo + 1);
                                            }
                                        }}
                                        onEnded={() => {
                                            if (currentVideo + 1 < playList.length) {
                                                setCurrentVideo(currentVideo + 1);
                                            }
                                        }}
                                    />
                                </div>
                            </Container>
                        )}
                    </div>

                    {/* 
                    {livestream.parent !== "638647e2afec127d1e023777" && (
                        <div className="px-4 pt-6 pb-[22px] flex items-center justify-between">
                            <button className="flex items-center">
                                <span>
                                    <svg
                                        width="15"
                                        height="13"
                                        viewBox="0 0 15 13"
                                        className="mr-2"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M13.8813 2.19354C14.1021 1.96843 14.2223 1.67069 14.2166 1.36304C14.2109 1.0554 14.0797 0.761873 13.8507 0.544302C13.6217 0.326732 13.3127 0.202104 12.9888 0.196676C12.665 0.191248 12.3516 0.305443 12.1146 0.515203L6.69798 5.66104C6.46389 5.88369 6.33241 6.18551 6.33241 6.5002C6.33241 6.81489 6.46389 7.11671 6.69798 7.33937L12.1146 12.4852C12.3516 12.695 12.665 12.8092 12.9888 12.8037C13.3127 12.7983 13.6217 12.6737 13.8507 12.4561C14.0797 12.2385 14.2109 11.945 14.2166 11.6374C14.2223 11.3297 14.1021 11.032 13.8813 10.8069L9.34798 6.5002L13.8813 2.19354ZM1.74798 12.8335C1.41646 12.8335 1.09852 12.7084 0.864095 12.4857C0.629674 12.263 0.497977 11.961 0.497977 11.646V1.35437C0.497977 1.03943 0.629674 0.73738 0.864095 0.514681C1.09852 0.291981 1.41646 0.16687 1.74798 0.16687C2.0795 0.16687 2.39744 0.291981 2.63186 0.514681C2.86628 0.73738 2.99798 1.03943 2.99798 1.35437V11.646C2.99798 12.3015 2.43798 12.8335 1.74798 12.8335Z"
                                            fill="#E38301"
                                        />
                                    </svg>
                                </span>
                                <p className="text-base font-medium text-ebony-color capitalize leading-none">
                                    Previous
                                </p>
                            </button>

                            <button className="flex flex-row-reverse items-center">
                                <span>
                                    <svg
                                        width="15"
                                        height="13"
                                        viewBox="0 0 15 13"
                                        className="ml-2 rotate-180"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M13.8813 2.19354C14.1021 1.96843 14.2223 1.67069 14.2166 1.36304C14.2109 1.0554 14.0797 0.761873 13.8507 0.544302C13.6217 0.326732 13.3127 0.202104 12.9888 0.196676C12.665 0.191248 12.3516 0.305443 12.1146 0.515203L6.69798 5.66104C6.46389 5.88369 6.33241 6.18551 6.33241 6.5002C6.33241 6.81489 6.46389 7.11671 6.69798 7.33937L12.1146 12.4852C12.3516 12.695 12.665 12.8092 12.9888 12.8037C13.3127 12.7983 13.6217 12.6737 13.8507 12.4561C14.0797 12.2385 14.2109 11.945 14.2166 11.6374C14.2223 11.3297 14.1021 11.032 13.8813 10.8069L9.34798 6.5002L13.8813 2.19354ZM1.74798 12.8335C1.41646 12.8335 1.09852 12.7084 0.864095 12.4857C0.629674 12.263 0.497977 11.961 0.497977 11.646V1.35437C0.497977 1.03943 0.629674 0.73738 0.864095 0.514681C1.09852 0.291981 1.41646 0.16687 1.74798 0.16687C2.0795 0.16687 2.39744 0.291981 2.63186 0.514681C2.86628 0.73738 2.99798 1.03943 2.99798 1.35437V11.646C2.99798 12.3015 2.43798 12.8335 1.74798 12.8335Z"
                                            fill="#E38301"
                                        />
                                    </svg>
                                </span>
                                <p className="text-base font-medium text-ebony-color capitalize leading-none">
                                    next
                                </p>
                            </button>
                        </div>
                    )} */}
                </div>
                {Routes.length > 0 &&
                    livestream.parent !== "638647e2afec127d1e023777" && (
                        <div className="w-full lg:w-[345px] bg-white m lg:h-full lg:overflow-hidden">
                            <div className="p-4 bg-white w-full">
                                <div className="mb-5">
                                    <ul className="flex items-center space-x-5 pb-[7px] border-b border-black-10">
                                        {Routes.map((route) => {
                                            return (
                                                <li key={route.id}>
                                                    <NavLink
                                                        to={`${route.path}`}
                                                        className={`text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap 
                                                        ${location.pathname.endsWith("/replay") && route.route === "info"
                                                                ? "active"
                                                                : ""
                                                            }`}
                                                    >
                                                        {route.route}
                                                    </NavLink>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>

                                <div className="">
                                    {!location.pathname.endsWith("/replay") ? (
                                        <Outlet />
                                    ) : (
                                        <Info />
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                {Routes.length > 0 &&
                    livestream.parent === "638647e2afec127d1e023777" && (
                        <div className="w-full lg:w-[345px] bg-white m lg:h-full lg:overflow-hidden">
                            <div className="p-4 bg-white w-full">
                                <div className="">
                                    <Product onlyProduct={true} />
                                </div>
                            </div>
                        </div>
                    )}
            </div>
            <Modal show={shareModal} onClose={() => setShareModal(false)}>
                <SharePop
                    onClose={() => setShareModal(false)}
                    shareUrl={shareUrl}
                    title={livestream.owner.fullName}
                    subTitle={"@" + livestream.owner.userName}
                    image={getImage(livestream.owner.attachments)}
                    heading="Share"
                />
            </Modal>
        </div>
    );
};

export default Replay;
